import { mstrPath } from "../../utils/mstrBase";

export const loadConfig = () => {
  return async (dispatch, _getState) => {
    let configApp = await fetchConfig(mstrPath("appConfig.json"));
    let filterConfig = await fetchConfig(mstrPath("filterConfig.json"));

    let config = { ...configApp, filterConfig: filterConfig };
    const messageBundles = await fetchMessageBundles(config.locale);

    config.messageBundles = messageBundles;
    dispatch({
      type: CONFIG_ACTIONS.LOAD,
      payload: {
        config: config,
      },
    });
  };
};
const fetchConfig = async (url) => {
  const res = await fetch(url);

  if (res.ok) {
    const config = await res.json();

    return config;
  } else throw Error("Failed to load configuration");
};

const fetchMessageBundles = async (language) => {
  const fileName = "MessageBundle_" + language + ".json";
  const res = await fetch(mstrPath(`messageBundles/${fileName}`));

  if (res.ok) {
    const messageBundles = await res.json();

    return messageBundles;
  } else throw Error("Failed to load message bundles");
};

export const CONFIG_ACTIONS = {
  LOAD: "LOAD",
};
